export { TicketsModule } from "./tickets.module";
export { TicketsComponent } from "./tickets.component";
export { TicketsRoutingModule } from "./tickets-routing.module";
export { OpenTicketsComponent } from "./open-tickets/open-tickets.component"
export { AwaitingTicketsComponent } from "./awaiting-tickets/awaiting-tickets.component"
export { ClosedTicketsComponent } from "./closed-tickets/closed-tickets.component"
export { AddAttachmentComponent } from "./add-attachment/add-attachment.component"
export { AddNoteComponent } from "./add-note/add-note.component"

